module.exports = __webpack_public_path__ + "h5/img/lottery.00da276a.png";